const history = {
  title: 'Proyek Saya',
  upgradeBtn: 'Tingkatkan',
  subTitle:
    'Jangan lupa untuk mengunduh file Anda karena akan dihapus setelah 72 jam.',
  MAgo: '{{num}} menit yang lalu',
  HAgo: '{{num}} jam yang lalu',
  DAgo: '{{num}} day ago',
  justNow: 'Baru saja',
  originalFile: 'berkas asli',
  selectAllBtn: 'Pilih Semua',
  emptyTips: 'Belum ada proyek. <1>Mulai mengedit</1>',
  deleteTips: 'Anda yakin ingin menghapusnya?',
};

export default history;
